import {FIELD_LIST_BENEFIT_MIRACULOUS_REFINING_SERIES} from "../../../utils/input-field-list-static-page";
import {useDispatch, useSelector} from "react-redux";
import {setMiraculousRefiningSeriesBenefitDetail} from "../../../reducers/miraculous-refining-series.reducer";
import {randomCode} from "../../../utils/general-variable";
import FormItemComponent from "../../../components/static-page/form-item.component";
import React from "react";
import ItemBenefit from "./item-benefit";

const Benefit = () => {
    const dispatch = useDispatch()
    const {benefitDetail} = useSelector(state => state.miraculousRefiningSeriesReducer)
    const itemList = [...benefitDetail.item_list]
    let fieldList = FIELD_LIST_BENEFIT_MIRACULOUS_REFINING_SERIES
    let showBenefit = {
        label: 'Benefit',
        key: 'show_benefit',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setMiraculousRefiningSeriesBenefitDetail({[key]: value}))
    }

    const addItemHandler = () => {
        itemList.push({
            id: randomCode(5, 1, 'benefit').toString(),
            thumbnail: null,
            title: null,
            description: null
        })
        dispatch(setMiraculousRefiningSeriesBenefitDetail({item_list: itemList}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        console.log(benefitDetail)
        // submit form
    }

    return (
        <FormItemComponent
            data={benefitDetail}
            switchToggleField={showBenefit}
            itemList={itemList}
            content={(index) => <ItemBenefit fieldList={fieldList} index={index}/>}
            onChange={onChange}
            setDataList={setMiraculousRefiningSeriesBenefitDetail}
            deleteList={benefitDetail?.delete_ids}
            addItemHandler={addItemHandler}
            onSubmitHandler={onSubmitHandler}
            isLoading={false}
        />
    )
}

export default Benefit
